import {createContext, FC, ReactNode, useContext, useMemo} from 'react';

import {Section, UIElement, UIRenderableElement} from '../types';

export const UIContext = createContext<UIElement[]>([]);

type UIContextProviderProps = {
    children: ReactNode;
    data: UIElement[];
};

const UIContextProvider: FC<UIContextProviderProps> = ({children, data}) => (
    <UIContext.Provider value={data}>{children}</UIContext.Provider>
);
export default UIContextProvider;

export const useSection = (sectionId: string) => {
    const data = useContext(UIContext);
    const section = useMemo(() => {
        const sections = data.filter(
            (item) => item.type === 'section',
        ) as Section[];

        return sections.find((item) => item.name === sectionId);
    }, [data, sectionId]);

    return section as Section | undefined;
};

export const useUIElements = (sectionId: string) => {
    const data = useContext(UIContext);
    const elements = useMemo(() => {
        const filteredElements = data.filter(
            (item) =>
                item.type === 'checkbox' || item.type === 'granular_right',
        ) as UIRenderableElement[];

        return filteredElements.filter((item) => item.section === sectionId);
    }, [data, sectionId]);

    return elements as UIRenderableElement[];
};
